import React from 'react';
import { Box } from '@chakra-ui/react';
import { motion, useScroll, useSpring } from 'framer-motion';

const MotionBox = motion.create(Box);

export default function ScrollProgressBar() {
	const { scrollYProgress } = useScroll();
	const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, restDelta: 0.001 });

	return (
		<MotionBox
			position='fixed'
			top={0}
			left={0}
			right={0}
			h='3px'
			zIndex={40}
			transformOrigin='0% 50%'
			style={{ scaleX }}
			bgGradient='linear(to-r, cyan.300, blue.400, purple.400)'
			boxShadow='0 0 12px rgba(34, 211, 238, 0.6)'
			aria-hidden
		/>
	);
}
